<template>
  <!-- <div class="image-dialog">
    <button class="image-dialog-trigger" type="button" @click="showDialog">
      <img
        class="image-dialog-thumb"
        ref="thumb"
        width="100%"
        src="@/assets/background.jpg"
      />
    </button>
    <transition name="dialog" @enter="enter" @leave="leave">
      <div class="image-dialog-background" v-show="appearedDialog" ref="dialog">
        <button
          class="image-dialog-close"
          type="button"
          @click="hideDialog"
          aria-label="Close"
        ></button
        ><img
          class="image-dialog-animate"
          ref="animate"
          :class="{ loading: !loaded }"
          width="100%"
          src="@/assets/GL_bg.jpg"
        /><img
          class="image-dialog-full"
          ref="full"
          width="100%"
          src="@/assets/GL_bg.jpg"
          @load="onLoadFull"
        />
      </div>
    </transition>
  </div> -->
  <!-- Button trigger modal -->
  <div>
    <button
      type="button"
      class="btn p-0"
      data-bs-toggle="modal"
      data-bs-target="#exampleModal"
    >
      <img
        class="image-dialog-thumb"
        ref="thumb"
        width="100%"
        src="@/assets/GL_bg.jpg"
      />
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <img width="100%" src="@/assets/GL_bg.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imagePath: String,
  },
};
</script>
<style></style>
